<template>
    <div class="fixed bottom-0 left-0 right-0 max-w-500 w-full grid grid-cols-3 gap-3 justify-items-center bg-white text-10 font-bold text-center mx-auto pt-2.5 pb-6 px-6 z-20 border border-t-a-gray-E8E9EB" data-cy="nav_menubar_bottom">
        <router-link to="/" data-cy="link_menubar_home">
            <div>
                <div class="pb-1.5">
                    <img :src="icMenuUrl('ic-menu-reward-active')" class="mx-auto" data-cy="icon_menubar_home_active" v-if="menuActive == 'home' || menuActive == 'default'"/>
                    <img :src="icMenuUrl('ic-menu-reward-inactive')" class="mx-auto" data-cy="icon_menubar_home_inactive" v-else />
                </div>
                <div :class="[menuActive == 'home' || menuActive == 'default' ? 'text-a-blue-0064ff' : 'text-a-blue-002850']" data-cy="text_menubar_home_label">
                    {{lbl.menubar.home}}
                </div>
            </div>
        </router-link>
        <router-link to="/mission" data-cy="btn_menubar_mission" @click="gotoPage('mission')">
            <div class="relative -mt-10">
                <div class="pb-1.5">
                    <img :src="icMenuUrl('ic-menu-mission-active')" class="mx-auto" data-cy="icon_menubar_mission_active" v-if="menuActive == 'mission'"/>
                    <img :src="icMenuUrl('ic-menu-mission-inactive')" class="mx-auto" data-cy="icon_menubar_mission_inactive" v-else />
                </div>
                <div :class="[menuActive == 'mission' ? 'text-a-blue-0064ff' : 'text-a-blue-002850']" data-cy="text_menubar_mission_label">
                    {{lbl.menubar.mission}}
                </div>
            </div>
        </router-link>
        <router-link to="/getfriend" data-cy="link_menubar_my" @click="gotoPage('me')">
            <div>
                <div class="pb-1.5">
                    <img :src="icMenuUrl('ic-menu-my-active')" class="mx-auto" data-cy="icon_menubar_my_active" v-if="isHistoryPage"/>
                    <img :src="icMenuUrl('ic-menu-my-inactive')" class="mx-auto" data-cy="icon_menubar_my_inactive" v-else />
                </div>
                <div :class="[isHistoryPage ? 'text-a-blue-0064ff' : 'text-a-blue-002850']" data-cy="text_menubar_my_label">
                    {{lbl.menubar.my}}
                </div>
            </div>
        </router-link>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ConfigManager from '@/config/ConfigManager.js';
export default {
    name: 'MenuBar',
    mixins: [ LocaleMixin ],
    data: function(){
        return {
            menuActive: null,
        }
    },
    computed: {
        isHistoryPage: function(){
            return (this.$route.name.indexOf('history') > -1);
        }
    },
    created: function(){
        this.menuActive = this.$route.name;
    },
    methods: {
        gotoPage: function(page){
            if (page == 'mission') {
                this.tracking.event('home_mission', 'click_mission', null, null)
            } else {
                this.tracking.event('home_me', 'click_me', null, null)
            }
        },
        icMenuUrl: function(name) {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/menu-newversion/${name}.svg`;
        },
    }
}
</script>
